import { useTranslation } from 'react-i18next';
import Iconify from 'src/components/Iconify';
import RealstateModuleConfig from './modules/RealstateModuleConfig';
import EcommerceModuleConfig from './modules/EcommerceModuleConfig';

export default function AiAgentModulosTab({ aiAgent, changeModuleConfig, changeTomConversa, changePersona }) {
    const { t } = useTranslation('settings');
    const currentType = aiAgent?.config?.module_agent_type || '';

    return (
        <div className="flex flex-col gap-6">
            {currentType === 'realestate' && (
                <RealstateModuleConfig aiAgent={aiAgent} changeModuleConfig={changeModuleConfig} changeTomConversa={changeTomConversa} changePersona={changePersona} />
            )}

            {currentType === 'ecommerce' && (
                <EcommerceModuleConfig aiAgent={aiAgent} changeModuleConfig={changeModuleConfig} changeTomConversa={changeTomConversa} changePersona={changePersona} />
            )}

            {!currentType && (
                <div className="flex flex-col items-center justify-center py-16 bg-white rounded-xl border border-dashed border-gray-200">
                    <div className="w-14 h-14 rounded-2xl flex items-center justify-center bg-gray-50 mb-3">
                        <Iconify icon="eva:layers-outline" width={28} className="text-gray-300" />
                    </div>
                    <p className="text-sm font-medium text-gray-700">{t('aiAgents.modulos.emptyTitle', 'Nenhum módulo selecionado')}</p>
                    <p className="text-xs text-gray-500 mt-1">{t('aiAgents.modulos.emptyDescription', 'Selecione um tipo de módulo na aba "Perfil" para configurá-lo.')}</p>
                </div>
            )}
        </div>
    );
}
